import { getConstraints } from "../../../utils";
import { initDevice } from "../../../utils";
import { EVENT_TRACER } from "../../../constants";
import { createImageFromBase64, cropImageFromGuide } from "./canvas";
import { reportEvent } from "../../../utils";
import { analyzeVirtualCamera } from "../../liveness/utils";
import { applyFocusSettings, getBestBackCamera, getOptimizedConstraints } from "../../../utils/camera-utils";
import { SDK_EVENT_KEYS } from "../../../utils/logService";

const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});

const emitReadyCam = params.emitReadyCam || "false";
const platform = params.platform || "web";
const isFront = params.isFront || "true";
const documentType = params.documentType;
const processId = params.processId;
const urlTracer = params.urlTracer;

export async function startCameraOld(
    cameraType,
    videoRef,
    canvasRef,
    containerRef,
    Stream,
    configValue,
    callbackAutoCapturing,
    onManualCapture,
    setConfigValues,
    initTimer,
    setLoading,
    responseToHostError,
    showGuide,
    selectedCameraId,
    updateDetectorStatus,
) {
    const constrains = getConstraints(initDevice().isMac, "environment");
    try {
        let selectedCameraId;
        const stream = await navigator.mediaDevices.getUserMedia(constrains);

        const videoTrack = stream.getVideoTracks()[0];
        const settings = videoTrack.getSettings();
        const isVirtual = analyzeVirtualCamera(videoTrack, settings);

        if (isVirtual) {
            onReportEvent(EVENT_TRACER.LIVENESS.LivenessCameraError, "Se detectó una camara virtual").catch();
            responseToHostError({ message: "Se detectó una camara virtual" });
            return;
        }

        let currentStream = stream;
        let constraintsMovil = constrains;
        if (initDevice().isAndroid || initDevice().isIos) {
            const videoInputs = await getVideoInputs();
            if (videoInputs.length > 0) {
                selectedCameraId = videoInputs[0]?.deviceId;
                constraintsMovil = {
                    video: {
                        deviceId: { exact: selectedCameraId },
                        width: { ideal: 1920 },
                        height: { ideal: 1080 },
                        advanced: [{ focusMode: "continuous" }],
                    },
                };
                if (!selectedCameraId) delete constraintsMovil.video.deviceId;
                stream.getVideoTracks()[0].stop();
                currentStream = await navigator.mediaDevices.getUserMedia(constraintsMovil);
            }
        }

        setTimeout(async () => {
            const video = videoRef.current;
            const canvas = canvasRef.current;
            const canvasContext = canvas.getContext("2d");
            canvasContext.imageSmoothingEnabled = true;

            onReportEvent(
                EVENT_TRACER.CARD_CAPTURE.CardCaptureCameraOpen,
                "Camara del card capture iniciada",
                urlTracer,
                processId,
            );
            const streamProperties = {
                device: initDevice(),
                modelPath: "/models",
                croppedImage: true,
                urlService: configValue.urlService,
                isFront,
                documentType,
                processId,
                onStatusChange: updateDetectorStatus,
                config: configValue,
            };
            const streamRef = Stream.getInstance(streamProperties);
            streamRef.updateHtmlElements(videoRef.current, canvasRef.current);
            streamRef.setFaceDetection(true);
            streamRef.setCallbackAutoCapturing(callbackAutoCapturing);
            streamRef.setCallbackFaceDetectionErrors(() => {
                if (!onManualCapture.current) {
                    containerRef.current.classList.add("danger");
                } else {
                    containerRef.current.classList.remove("danger");
                    containerRef.current.classList.remove("success");
                }
            });
            await setConfigValues();
            initTimer();
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            showGuide();
            await streamRef.startDetection();
            setLoading(false);
            responseToHostReadyCam();
            video.muted = true;
            video.srcObject = currentStream;
        }, 3000);
    } catch (error) {
        await onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureCameraError, error.message);
        setLoading(false);
        responseToHostError(cameraType, error.message);
    }
}


const obtenerModeloTecnicoDispositivo = async () => {
    // Verificar si el navegador soporta User-Agent Client Hints (UA-CH)
    if (!navigator.userAgentData) {
        return null;
    }

    const hints = ['model', 'platform', 'platformVersion'];

    try {
        const data = await navigator.userAgentData.getHighEntropyValues(hints);

        const modelo = data?.model;
        const plataforma = data?.platform;
        const versionSO = data?.platformVersion;
        const marca = data?.brands ? (data?.brands[0]?.brand || 'N/A') : 'N/A';

        const info = {
            modelo,
            plataforma,
            versionSO,
            marca
        };

        if (modelo && modelo !== '') {
            return info;
        } else {
            return info;
        }

    } catch (error) {
        console.error('Error al solicitar Client Hints:', error);
        return null;
    }
};

export async function startCamera(
    cameraType,
    videoRef,
    canvasRef,
    containerRef,
    Stream,
    configValue,
    callbackAutoCapturing,
    onManualCapture,
    setConfigValues,
    initTimer,
    setLoading,
    responseToHostError,
    showGuide,
    selectedCameraId,
    updateDetectorStatus,
    setCurrentStream,
    initCameraManualWithUI
) {

    let intialized = false
    const deviceInfo = initDevice()

    try {
        onReportEvent(SDK_EVENT_KEYS.InitConfigCamera, {}, 'CardCapture').catch()
        // Obtener configuraciones optimizadas
        onReportEvent(SDK_EVENT_KEYS.ApplyConstraints, {}, 'CardCapture').catch()
        const constraints = await getOptimizedConstraints(deviceInfo, cameraType)

        console.log("Using constraints:", constraints)

        // Solicitar permisos y obtener stream
        onReportEvent(SDK_EVENT_KEYS.GetCameraPermissions, {}, 'CardCapture').catch()
        let currentStream = await navigator.mediaDevices.getUserMedia(constraints)
        onReportEvent(SDK_EVENT_KEYS.GetCameraPermissionsSuccess, {}, 'CardCapture').catch()

        const videoTrack = currentStream.getVideoTracks()[0];
        const settings = videoTrack.getSettings();
        onReportEvent(SDK_EVENT_KEYS.VirtualCameraValidation, {}, 'CardCapture').catch()
        const isVirtual = analyzeVirtualCamera(videoTrack, settings);

        if (isVirtual) {
            onReportEvent(SDK_EVENT_KEYS.VirtualCameraFound, {}, 'CardCapture').catch()
            onReportEvent(SDK_EVENT_KEYS.VirtualCameraValidationEnd, {}, 'CardCapture').catch()
            responseToHostError(cameraType, "Se detectó una camara virtual")
            return
        }

        onReportEvent(SDK_EVENT_KEYS.VirtualCameraNotFound, {}, 'CardCapture').catch()
        onReportEvent(SDK_EVENT_KEYS.VirtualCameraValidationEnd, {}, 'CardCapture').catch()

        // Para dispositivos móviles, intentar obtener la mejor cámara trasera
        if (deviceInfo.isIos || deviceInfo.isAndroid) {
            try {
                onReportEvent(SDK_EVENT_KEYS.InitGetBestCamera, {}, 'CardCapture').catch()
                // onReportEvent(EVENT_TRACER.SERVICE.InitGetBestCamera, "Iniciando busqueda de mejor camara").catch();
                const model = await obtenerModeloTecnicoDispositivo();
                const bestCamera = await getBestBackCamera(model?.modelo)
                const videoInputs = await getVideoInputs()
                const backCameraKeywords = [
                    'Facing back:/dev/video10',
                    // Inglés
                    "back", "rear", "environment", "main", "primary",
                    "world", "outer", "external", "outward", "facing-back",

                    // Español
                    "trasera", "posterior", "principal", "externa",
                    "exterior", "ambiente", "mundo", "primaria",

                    // Francés
                    "arrière", "principale", "environnement", "extérieure",
                    "externe", "primaire", "dorsale", "verso",

                    // Portugués
                    "traseira", "principal", "ambiente", "externa",
                    "exterior", "primária", "mundo", "dorsal",

                    // Italiano
                    "posteriore", "principale", "ambiente", "esterna",
                    "esterno", "primaria", "retro", "dorsale",

                    // Alemán
                    "hinten", "rück", "haupt", "umgebung",
                    "außen", "primär", "extern", "rückseitig", "äußere",

                    // Chino simplificado
                    "后置", "主摄像头", "后摄", "主摄",
                    "后置摄像头", "环境", "外置", "背面",

                    // Chino tradicional
                    "後置", "主攝像頭", "後攝", "背面",

                    // Coreano
                    "후면", "메인", "후방", "외부",
                    "주", "환경", "뒷면", "외측",

                    // Japonés
                    "背面", "メイン", "後方", "外側",
                    "リア", "アウト", "主", "環境",

                    // Neerlandés
                    "achter", "achterkant", "hoofd", "primair",
                    "extern", "omgeving",

                    // Ruso
                    "задняя", "основная", "тыльная", "внешняя",
                    "главная", "среда",

                    // Árabe
                    "خلفي", "خلفية", "رئيسي", "رئيسية",
                    "بيئة", "خارجي",

                    // Hindi
                    "पीछे", "मुख्य", "पिछला", "बाहरी",

                    // Términos técnicos comunes
                    "cam0", "camera0", "cam-0", "camera-0",
                    "cam_0", "camera_0", "ultra-wide-back",
                    "wide-back", "telephoto-back", "env",

                    // Variaciones con guiones y espacios
                    "back-facing", "back_facing", "rear-facing", "rear_facing",
                    "outward-facing", "outward_facing", "world-facing", "world_facing"
                ];
                const labelsTraseras = (() => {
                    const list = (videoInputs || [])
                        .filter(d => backCameraKeywords.some(k => d.label?.toLowerCase().includes(k)))
                        .map(d => d.label);
                    return list.length ? list.join(', ') : '';
                })();

                onReportEvent(SDK_EVENT_KEYS.ListBestCamera, {cameras: labelsTraseras}, 'CardCapture').catch()
                onReportEvent(SDK_EVENT_KEYS.SelectedBestCamera, {camera: bestCamera.label}, 'CardCapture').catch()

                if (bestCamera?.deviceId && bestCamera.deviceId !== currentStream.getVideoTracks()[0].getSettings().deviceId) {
                    // Detener stream actual
                    currentStream.getVideoTracks()[0].stop()

                    // Crear nuevas constraints con la mejor cámara
                    const optimizedConstraints = await getOptimizedConstraints(deviceInfo, cameraType)
                    optimizedConstraints.video.deviceId = bestCamera.deviceId

                    onReportEvent(SDK_EVENT_KEYS.EndGetBestCamera, {}, 'CardCapture').catch()


                    // Obtener nuevo stream
                    currentStream = await navigator.mediaDevices.getUserMedia(optimizedConstraints)
                }
            } catch (error) {
                console.warn("Could not get best camera, using current stream:", error)
            }
        }

        // Configurar video element
        const video = videoRef.current
        const canvas = canvasRef.current

        if (!video || !canvas) {
            throw new Error("Video or canvas element not found")
        }
        if (setCurrentStream) {
            setCurrentStream(currentStream)
        }
        video.srcObject = currentStream
        video.muted = true
        video.playsInline = true
        video.autoplay = true

        // Esperar a que el video esté listo
        await new Promise((resolve, reject) => {
            const timeout = setTimeout(() => {
                reject(new Error("Video load timeout"))
            }, 10000)

            video.onloadedmetadata = () => {
                clearTimeout(timeout)
                resolve()
            }

            video.onerror = () => {
                clearTimeout(timeout)
                reject(new Error("Video load error"))
            }
        })

        // Aplicar configuraciones de enfoque
        await applyFocusSettings(currentStream)

        // Configurar canvas
        const canvasContext = canvas.getContext("2d")
        canvasContext.imageSmoothingEnabled = true

        // Esperar un momento para que el video se estabilice
        setTimeout(
            async () => {
                try {
                    // Configurar dimensiones del canvas
                    canvas.width = video.videoWidth || 1920
                    canvas.height = video.videoHeight || 1080

                    // Para iOS, intentar enfocar manualmente después de un delay
                    if (deviceInfo.isIos) {
                        setTimeout(async () => {
                            try {
                                const track = currentStream.getVideoTracks()[0]
                                const capabilities = track.getCapabilities()

                                if (capabilities.focusMode && capabilities.focusMode.includes("single-shot")) {
                                    await track.applyConstraints({
                                        advanced: [{ focusMode: "single-shot" }],
                                    })
                                }

                                onReportEvent(SDK_EVENT_KEYS.ServiceCameraOpen, {}, 'CardCapture').catch()
                                const streamProperties = {
                                    device: initDevice(),
                                    modelPath: '/models',
                                    croppedImage: true,
                                    urlService: configValue.urlService,
                                    isFront,
                                    documentType,
                                    processId,
                                    onStatusChange: updateDetectorStatus
                                }
                                const streamRef = Stream.getInstance(streamProperties)
                                streamRef.updateHtmlElements(videoRef.current, canvasRef.current)
                                streamRef.setFaceDetection(true);
                                streamRef.setCallbackAutoCapturing(callbackAutoCapturing)
                                streamRef.setCallbackFaceDetectionErrors(() => {
                                    if (!onManualCapture.current) {
                                        containerRef.current.classList.add('danger')
                                    } else {
                                        containerRef.current.classList.remove('danger')
                                        containerRef.current.classList.remove('success')
                                    }
                                })
                                onReportEvent(SDK_EVENT_KEYS.InitConfigValues, {}, 'CardCapture').catch()
                                await setConfigValues()
                                onReportEvent(SDK_EVENT_KEYS.ApplyConfigValue, {}, 'CardCapture').catch()
                                initTimer()
                                canvas.width = video.videoWidth;
                                canvas.height = video.videoHeight;
                                onReportEvent(SDK_EVENT_KEYS.InitShowGuide, {}, 'CardCapture').catch()
                                showGuide()
                                onReportEvent(SDK_EVENT_KEYS.EndShowGuide, {}, 'CardCapture').catch()


                                if (configValue?.configCamera) {
                                    // automatica con timeout para manual
                                    if (configValue?.configCamera?.onlyAutomatic === false && configValue?.configCamera?.onlyManual === false) {
                                        await streamRef.startDetection()
                                    }

                                    // automatica sin timeout
                                    if (configValue?.configCamera?.onlyAutomatic) {
                                        console.log('llego a captura automatica sin timeout')
                                        await streamRef.startDetection()
                                    }

                                    // solo manual
                                    if (configValue?.configCamera?.onlyManual) {
                                        if (initCameraManualWithUI) {
                                            initCameraManualWithUI();
                                        }
                                    }
                                } else {
                                    await streamRef.startDetection()
                                }

                                setLoading(false)
                                intialized = true
                                responseToHostReadyCam()

                            } catch (focusError) {
                                console.warn("Manual focus failed:", focusError)
                            }
                        }, 2000)

                        return
                    }
                    onReportEvent(SDK_EVENT_KEYS.ServiceCameraOpen, {}, 'CardCapture').catch()

                    const streamProperties = {
                        device: initDevice(),
                        modelPath: '/models',
                        croppedImage: true,
                        urlService: configValue.urlService,
                        isFront,
                        documentType,
                        processId,
                        onStatusChange: updateDetectorStatus
                    }
                    const streamRef = Stream.getInstance(streamProperties)
                    streamRef.updateHtmlElements(videoRef.current, canvasRef.current)
                    streamRef.setFaceDetection(true);
                    streamRef.setCallbackAutoCapturing(callbackAutoCapturing)
                    streamRef.setCallbackFaceDetectionErrors(() => {
                        if (!onManualCapture.current) {
                            containerRef.current.classList.add('danger')
                        } else {
                            containerRef.current.classList.remove('danger')
                            containerRef.current.classList.remove('success')
                        }
                    })
                    onReportEvent(SDK_EVENT_KEYS.InitConfigValues, {}, 'CardCapture').catch()
                    await setConfigValues()
                    onReportEvent(SDK_EVENT_KEYS.ApplyConfigValue, {}, 'CardCapture').catch()
                    initTimer()
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    onReportEvent(SDK_EVENT_KEYS.InitShowGuide, {}, 'CardCapture').catch()
                    showGuide()
                    onReportEvent(SDK_EVENT_KEYS.EndShowGuide, {}, 'CardCapture').catch()
                    await streamRef.startDetection()
                    responseToHostReadyCam()

                    setLoading(false)
                } catch (setupError) {
                    console.error("Error in camera setup:", setupError)
                    setLoading(false)
                }
            },
            deviceInfo.isIos ? 4000 : 3000,
        )
    } catch (error) {
        console.error("Error starting camera:", error)
        setLoading(false)

        try {
            const basicConstraints = {
                audio: false,
                video: {
                    facingMode: cameraType,
                    width: { ideal: 1280 },
                    height: { ideal: 720 },
                },
            }

            const fallbackStream = await navigator.mediaDevices.getUserMedia(basicConstraints)
            const video = videoRef.current

            if (video) {
                video.srcObject = fallbackStream
                video.muted = true
                video.playsInline = true

                setTimeout(() => {
                    const canvas = canvasRef.current
                    if (canvas) {
                        canvas.width = video.videoWidth || 1280
                        canvas.height = video.videoHeight || 720
                    }
                    initTimer()
                    showGuide()
                    setLoading(false)
                }, 3000)
            }
        } catch (fallbackError) {
            console.error("Fallback camera failed:", fallbackError)
            onReportEvent(SDK_EVENT_KEYS.ConfigCameraError, {}, 'CardCapture').catch()
            responseToHostError && responseToHostError("Camera initialization failed")
        }
    }
}

export async function startCameraTest(
    cameraType,
    videoRef,
    canvasRef,
    containerRef,
    Stream,
    configValue,
    callbackAutoCapturing,
    onManualCapture,
    setConfigValues,
    initTimer,
    setLoading,
    responseToHostError,
    showGuide,
    deviceId,
    setVideoDevices,
    setCameraSelectedDefault,
) {
    if (videoRef.current?.srcObject) {
        const tracks = videoRef.current.srcObject.getTracks();
        tracks.forEach((track) => track.stop());
    }

    const constrains = getConstraints(initDevice().isMac, "environment");
    try {
        let selectedCameraId;
        const stream = await navigator.mediaDevices.getUserMedia(constrains);

        let currentStream = stream;
        let constraintsMovil = constrains;
        if (initDevice().isAndroid || initDevice().isIos) {
            const devices = await navigator.mediaDevices.enumerateDevices();

            const backCameraKeywords = [
                "back",
                "rear",
                "environment",
                "main",
                "trasera",
                "posterior",
                "principal",
                "arrière",
                "principale",
                "environnement",
                "traseira",
                "principal",
                "ambiente",
                "posteriore",
                "hinten",
                "rück",
                "后置",
                "主摄像头",
                "후면",
                "메인",
                "背面",
                "メイン",
            ];
            const videoInputs2 = devices.filter((device) => device.kind === "videoinput");
            const backCameras = videoInputs2.filter(
                (device) =>
                    backCameraKeywords.some((keyword) => device.label.toLowerCase().includes(keyword)) ||
                    device.facingMode === "environment",
            );

            let videoInputs = backCameras;

            if (videoInputs.length <= 0) {
                videoInputs = devices.filter(
                    (device) => device.kind === "videoinput" && device.label.includes("facing back"),
                );
            }
            if (videoInputs.length > 0) {
                setVideoDevices(videoInputs);
                selectedCameraId = videoInputs[0];
                setCameraSelectedDefault(selectedCameraId.label);
                constraintsMovil = {
                    video: {
                        deviceId: { exact: deviceId || selectedCameraId.deviceId },
                        width: { ideal: 1920 },
                        height: { ideal: 1080 },
                        advanced: [{ focusMode: "continuous" }],
                    },
                };
                stream.getVideoTracks()[0].stop();
                currentStream = await navigator.mediaDevices.getUserMedia(constraintsMovil);
            }
        }

        setTimeout(async () => {
            const video = videoRef.current;
            const canvas = canvasRef.current;
            const canvasContext = canvas.getContext("2d");
            canvasContext.imageSmoothingEnabled = true;

            onReportEvent(
                EVENT_TRACER.CARD_CAPTURE.CardCaptureCameraOpen,
                "Camara del card capture iniciada",
                urlTracer,
                processId,
            );
            await setConfigValues();
            initTimer();
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            showGuide();
            setLoading(false);
            responseToHostReadyCam();
            video.muted = true;
            video.srcObject = currentStream;
        }, 3000);
    } catch (error) {
        await onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureCameraError, error.message);
        setLoading(false);
        responseToHostError(cameraType, error.message);
    }
}

export const forceFocus = async (videoRef) => {
    try {
        const video = videoRef.current;
        if (!video || !video.srcObject) return false;

        const stream = video.srcObject;
        const track = stream.getVideoTracks()[0];
        const capabilities = track.getCapabilities();

        if (capabilities.focusMode && capabilities.focusMode.includes("single-shot")) {
            await track.applyConstraints({
                advanced: [{ focusMode: "single-shot" }],
            });
            return true;
        }

        return false;
    } catch (error) {
        return false;
    }
};

export const optimizeImageQuality = async (videoRef) => {
    try {
        const video = videoRef.current;
        if (!video || !video.srcObject) return;

        const stream = video.srcObject;
        const track = stream.getVideoTracks()[0];
        const capabilities = track.getCapabilities();

        const optimizations = {};

        if (capabilities.exposureCompensation) {
            optimizations.exposureCompensation = 0;
        }

        if (capabilities.iso) {
            optimizations.iso = Math.min(capabilities.iso.max, 400);
        }

        if (capabilities.sharpness) {
            optimizations.sharpness = capabilities.sharpness.max * 0.8;
        }

        if (Object.keys(optimizations).length > 0) {
            await track.applyConstraints({ advanced: [optimizations] });
        }
    } catch (error) {}
};

export function stopCamera(videoRef) {
    try {
        const stream = videoRef.current.srcObject;
        if (stream) {
            const tracks = stream.getTracks();
            tracks.forEach((track) => track.stop());
        }
        videoRef.current.srcObject = null;
    } catch (e) {}
}

function responseToHostReadyCam() {
    if (emitReadyCam === "true") {
        const message = "ado-cam-ready";

        if (platform === "ios") {
            window.webkit.messageHandlers.messageHandlersName.postMessage(message);
            return;
        }

        if (platform === "android") {
            window.ResponseAdo.handleEvent(message);
            return;
        }

        if (platform === "react-native") {
            window.ReactNativeWebView.postMessage(message);
            return;
        }
        if (platform === "web") {
            window.parent.postMessage(message, "*");
        }
    }
}

export async function getVideoInputs() {
    const devices = await navigator.mediaDevices.enumerateDevices();
    let videoInputs = [];

    videoInputs = devices.filter((device) => device.kind === "videoinput");

    let rearCameras;

    rearCameras = videoInputs.filter((device) =>
        ["rear", "Rear Camera"].some((label) => device.label.toLowerCase().includes(label.toLowerCase())),
    );

    if (rearCameras.length > 0) return rearCameras;

    rearCameras = videoInputs.filter(
        (device) => device.label.includes("facing back") && device.label.includes("0"),
    );

    if (rearCameras.length > 0) return rearCameras;

    rearCameras = videoInputs.filter((device) =>
        ["back", "facing back", "Back Camera"].some((label) =>
            device.label.toLowerCase().includes(label.toLowerCase()),
        ),
    );

    if (rearCameras.length > 0) return rearCameras;

    rearCameras = videoInputs.filter((device) =>
        ["Back Triple Camera", "Cámara trasera"].some((label) =>
            device.label.toLowerCase().includes(label.toLowerCase()),
        ),
    );

    if (rearCameras.length > 0) return rearCameras;

    if (rearCameras.length <= 0) {
        rearCameras = videoInputs.filter(
            (device) =>
                device.label.toLowerCase().includes("front") ||
                device.label.toLowerCase().includes("webcam") ||
                device.label.toLowerCase().includes("integrated"),
        );
    }

    return rearCameras;
}

export function updateBorder(color, guideAdo, videoRef) {
    if (isMovil() && guideAdo.current) {
        guideAdo.current.style.border = `3px solid ${color}`;
    } else {
        videoRef.current.style.border = `5px solid ${color}`;
    }
}

export function responseToHost(
    type,
    image,
    imageCropped,
    additionalData,
    timer,
    showStep,
    finished,
    videoRef,
    guideAdo,
    textPreview,
) {
    clearInterval(timer);
    showStep("responseToHost");
    finished.current = true;

    if (videoRef.current) {
        videoRef.current.style.display = "none";
    }
    if (guideAdo.current) {
        guideAdo.current.style.display = "none";
    }
    if (textPreview.current) {
        textPreview.current.style.display = "none";
    }

    stopCamera(videoRef);

    onReportEvent(
        EVENT_TRACER.CARD_CAPTURE.CardCaptureResponseToHost,
        "El servicio emitio al host",
        urlTracer,
        processId,
    ).catch();
    const payload = {
        type: "success",
        step: type === 1 ? "frontCapture" : "backCapture",
        data: imageCropped,
        cropped: imageCropped,
        documentType: additionalData,
    };

    if (platform === "ios") {
        window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify(payload));
        return;
    }

    if (platform === "android") {
        window.ResponseAdo.handleEvent(JSON.stringify(payload));
        return;
    }

    if (platform === "react-native") {
        window.ReactNativeWebView.postMessage(JSON.stringify(payload));
        return;
    }
    window.parent.postMessage(JSON.stringify(payload), "*");
}

export function isMovil() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export async function onReportEvent(eventType, params = {}, processType = "Liveness") {
    if (!urlTracer) return;
    try {
        const response = await reportEvent(urlTracer, processId, eventType, params, processType);
    } catch (e) {}
}
